module.exports = __webpack_public_path__ + "static/media/opening.606dc896.gif";